import { gql } from '@apollo/client';

const getMylistQuery = () => {
  const mylistQuery = gql`
    query Mylist($customerAccountID: String! $userId: String! $customerType: CustomerType = B2C) {
      listDetails(customerAccountID: $customerAccountID userId: $userId customerType: $customerType) {
       listResponse {
          memberId
          listOfListsSize
          noOfLists
          listSize
          listDetails {
            listId
            listName
            lastModifiedDate
            noOfItems
            listType
            listAccessType
            lastUpdatedItemId
            lastUpdatedItemIds
            firstOrderItemURL
            items {
              itemId
              qty
              lastModifiedDate
              __typename
            }
            __typename
          }
          __typename
       }
        __typename
      }
    }
  `;
  return mylistQuery;
};

export default getMylistQuery;
